/**
 * Base URL configuration for IDWS API
 *
 * This file contains the base URL for all API endpoints.
 * The base URL does not include route-specific prefixes like 'auth'
 * as those are handled in their respective API modules.
 */

// Development base URL
// export const BASE_URL = 'http://127.0.0.1:8000/api'
export const BASE_URL = 'https://admin.digitalworkplacesummit.org/api'


// You can easily switch between environments by uncommenting the appropriate line:
// export const BASE_URL = 'https://api.idws.com/api' // Production
// export const BASE_URL = 'https://staging-api.idws.com/api' // Staging

export default BASE_URL